import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import { findByUsuario } from './api-usuario-perfil';
import { changePerfil } from './api-usuario';
import { setUsuario } from './actions/actions';
import { useSelector, useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import TableCell from '@mui/material/TableCell';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import Typography from '@mui/material/Typography';
import { errorMessage } from '../../util/ConfirmAlertUtil';
import { Grid } from '@mui/material';
import GridPaper from '../../util/GridPaper';


export default function UsuarioPerfilTable() {
    const usuario = useSelector(state => state.usuario);
    const [usuarioPerfis, setUsuarioPerfis] = useState([]);
    const dispatch = useDispatch();

    useEffect(() => {
        if (usuario && usuario.id) {
            findByUsuario(usuario.id).then((data) => {
                if (data.error) {
                    errorMessage(data.message)
                } else {
                    setUsuarioPerfis(data);
                }
            });
        }

    }, [usuario]);


    const handleAtivar = (perfil) => {
        changePerfil(perfil).then((data) => {
            if (data.error) {
                errorMessage(data.message);
            } else {
                dispatch(setUsuario(data));
                toast.success("Perfil Ativo Alterado.", {
                    position: "bottom-left"
                });
            }
        });
    }

    return (
        <>
            {usuarioPerfis.length > 0 ?

                <Grid container spacing={2} direction='column'>
                    <Grid>
                        <Typography variant="h5">
                            Alterar Perfil Ativo
                        </Typography>
                    </Grid>
                    <GridPaper >
                        <Table size="small" aria-label="a dense table">
                            <TableHead>
                                <TableRow>
                                    <TableCell>Perfil</TableCell>
                                    <TableCell>Ações</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {usuarioPerfis.map((up) => (
                                    <TableRow key={up.codigo}>
                                        <TableCell>{up.perfil}</TableCell>
                                        <TableCell>
                                            {usuario.perfil !== up.perfil ?
                                                <Button
                                                    type="submit"
                                                    variant="contained"
                                                    color="secondary"
                                                    onClick={() => handleAtivar(up.perfil)}
                                                >
                                                    Ativar
                                                </Button>
                                                : 'Selecionado'}

                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </GridPaper>
                </Grid >

                : ''
            }
        </>
    );
}